export default "__VITE_ASSET__77de8a80__"